var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQ4Icon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1005_479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 47,
    width: 146,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127 47H272.333V121.698H127V47Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1005_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.651 100.615C168.354 101.047 167.49 101.479 166.193 101.479C163.594 101.479 161 100.182 159.703 97.5885L145.005 70.349L138.953 72.9427C129.438 76.8333 124.682 87.6406 128.573 97.5885L129.005 98.8854L152.787 120.938C183.484 114.448 215.479 114.448 245.745 120.938L269.526 98.8854L269.958 97.5885C273.849 88.0729 269.094 76.8333 259.583 72.9427L252.234 69.9167L237.964 96.2917C236.667 98.8854 234.073 100.182 231.479 100.182C230.182 100.182 229.318 99.75 228.021 99.3177C224.563 97.5885 223.266 92.8333 224.995 89.3698L242.287 57.375C238.828 51.3229 232.344 47 224.563 47H173.974C165.76 47 158.839 51.7552 155.38 59.1042L172.677 91.1042C174.406 94.1302 173.109 98.8854 169.651 100.615Z",
    fill: "#435B63"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1005_479",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 127,
    width: 274,
    height: 227
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 127.031H336.333V353.797H63V127.031Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1005_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.479 133.042C216.344 125.26 183.052 125.26 151.49 132.609C123.818 155.094 72.3645 209.14 64.5833 273.13C61.5572 296.047 66.3124 315.073 78.8489 328.906C90.0937 341.448 105.224 347.932 117.766 350.958C189.104 350.526 221.536 332.364 250.505 312.479C253.964 310.312 258.286 312.042 260.448 315.505C262.177 318.963 260.448 322.422 257.422 325.448C241.854 340.583 228.453 348.797 216.344 353.984H260.016C262.177 353.984 298.495 353.552 320.115 329.338C332.656 315.505 337.411 296.479 334.385 273.562C326.167 209.573 275.151 155.526 247.479 133.042ZM183.484 225.135L199.052 228.161L218.505 232.057L219.807 232.489L220.672 232.922C234.505 239.838 237.531 248.052 237.531 253.672V254.536C237.531 268.375 224.562 279.614 208.13 279.614V292.156H193.432V279.614H190.401C174.406 279.614 161 268.375 161 254.536V248.917H175.703V254.536C175.703 260.161 182.62 264.917 190.401 264.917H208.13C215.911 264.917 222.833 260.161 222.833 254.536V253.672C222.833 252.375 220.672 249.781 215.047 246.323L180.891 239.406L178.729 238.974L177.865 238.542C167.057 232.922 161.432 226 161.432 218.219V217.354C161.432 203.521 174.406 192.276 190.833 192.276H193.865V180.604H208.13V192.276C224.13 192.276 237.531 203.521 237.531 217.354H222.833C222.833 211.734 215.911 206.979 208.13 206.979H190.401C182.62 206.979 175.703 211.734 175.703 217.354V218.219C175.703 219.515 177.432 222.109 183.484 225.135Z",
    fill: "#435B63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4Icon3);
export default __webpack_public_path__ + "static/media/q4-icon3.033f0c8c9683302556b646ab06b6ec9f.svg";
export { ForwardRef as ReactComponent };